import React, {useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import "./MatchedSitesModal.scss";

const MatchedSitesModal = ({onHide, sites, onSave}) => {
    const [selectedSiteIds, setSelectedSiteIds] = useState([]);

    const toggleSite = siteId => {
        if (selectedSiteIds.includes(siteId)) {
            setSelectedSiteIds(selectedSiteIds.filter(id => id !== siteId));
        } else {
            setSelectedSiteIds(selectedSiteIds.concat(siteId));
        }
    };

    return (
        <Modal
            id="matched-sites-modal"
            show
            onHide={onHide}
            backdrop="static"
            bsSize="large"
            className="heightAuto maxHeight90 fontIOS"
        >
            <Modal.Header closeButton>
                <Modal.Title>Select Sites To Update</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{maxHeight: "500px"}}>
                <h4 className="text-center mt-0">
                    More than one site matches the previous billing address. Select one or more sites to update.
                </h4>
                <Row>
                    {sites?.map(site => (
                        <Col xs={12} sm={6} key={site.id} className="mb-10">
                            <div
                                className={`matched-site-card ${selectedSiteIds.includes(site.id) ? "selected" : ""}`}
                                onClick={() => toggleSite(site.id)}
                            >
                                <Row>
                                    <Col xs={12}><b>{site.name || `Site #${site.id}`}</b></Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>{site.full_address}</Col>
                                </Row>
                                <Row>
                                    <Col xs={12} className="fontSize10">ID: {site.id}</Col>
                                </Row>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="warning" onClick={onHide}>
                    Cancel
                </Button>
                <Button
                    bsStyle="success"
                    disabled={!selectedSiteIds.length}
                    onClick={() => onSave(selectedSiteIds)}
                >
                    Update Selected Sites
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MatchedSitesModal;
